import { Record } from 'immutable';

const UnitOnlineUsageRecord = Record({
  unitNo: undefined,
  activitiesComplete: undefined,
  catchUpsTaken: undefined,
  unitAverage: undefined,
});

class UnitOnlineUsage extends UnitOnlineUsageRecord { }


export default UnitOnlineUsage;



// WEBPACK FOOTER //
// ./data/OnlineUsage/UnitOnlineUsage/model.js